export default __webpack_public_path__ + "static/media/cloud5.2b00aa33.png";